/**
 * @typedef {string} MarkdownId マークダウンID
 * @typedef {"common"|"text"|"recipe"} MarkdownType マークダウンタイプ
 * @typedef {{ id: MarkdownId, title: string, type: MarkdownType, asyncImport: Promise<string> }} Markdown マークダウンオブジェクト
 */

import { Chapter, CHAPTER_ID } from "@/lib/chapter"
import { Markdown } from "@/lib/markdown"

/**
 * Chapter は new Chapter で登録した順番に一覧に表示される
 */

// 404ページ - そのまま保持
new Markdown({
  id: "404",
  title: "ページが見つかりません",
  type: "common",
  asyncImport: () => import(/* webpackChunkName: "common" */ "./404.md"),
})

// articlesディレクトリから記事を動的に読み込み
const articlesContext = require.context("./articles", false, /\.md$/)

// 全ての記事を処理してフロントマターを抽出
const articles = articlesContext
  .keys()
  .map((fileName) => {
    const module = articlesContext(fileName)

    const frontmatter = module.frontmatter || {}

    return {
      fileName,
      ...frontmatter,
      asyncImport: () => Promise.resolve({ default: module.default || module }),
    }
  })
  .filter((article) => {
    const hasRequired = article.id && article.title && article.chapter
    return hasRequired
  })

// 記事をチャプター別にグループ化
const chapterGroups = articles.reduce((acc, article) => {
  if (!acc[article.chapter]) {
    acc[article.chapter] = []
  }
  acc[article.chapter].push(article)
  return acc
}, {})

// 各チャプター内で記事を順序でソート
Object.keys(chapterGroups).forEach((chapter) => {
  chapterGroups[chapter].sort((a, b) => (a.order || 0) - (b.order || 0))
})

// チャプターIDからタイトルへのマップ
const CHAPTER_TITLES = {
  [CHAPTER_ID.pre]: "WebExpert コースについて",
  [CHAPTER_ID.html_css]: "HTML・CSS",
  [CHAPTER_ID.setup]: "学習の手引き",
  [CHAPTER_ID.pc]: "パソコン",
  [CHAPTER_ID.js_basic]: "JavaScript の基礎",
  [CHAPTER_ID.js_dom]: "DOM",
  [CHAPTER_ID.recipe1]: "レシピ - レベル１",
  [CHAPTER_ID.programming]: "プログラミングの考え方",
  [CHAPTER_ID.recipe2]: "レシピ - レベル２",
  [CHAPTER_ID.vue_pre]: "Vue.js 準備",
  [CHAPTER_ID.vue_cli]: "Vue CLI",
  [CHAPTER_ID.web_design]: "Webデザイン",
  [CHAPTER_ID.react]: "React",
  [CHAPTER_ID.git]: "git と GitHub",
  [CHAPTER_ID.geek_twitter]: "GeekTwitter",
  [CHAPTER_ID.geek_twitter_with_react]: "GeekTwitterをつくる",
  [CHAPTER_ID.firebase]: "Firebase",
  [CHAPTER_ID.team_development]: "チーム開発",
}

// 全てのチャプター用のChapterインスタンスを作成（記事がなくても）
Object.entries(CHAPTER_TITLES).forEach(([chapterId, title]) => {
  const markdowns = chapterGroups[chapterId] || []

  new Chapter({
    id: chapterId,
    title: title,
    markdowns: markdowns.map((md) => ({
      id: md.id,
      title: md.title,
      type: md.type,
      time: md.time,
      asyncImport: md.asyncImport,
    })),
  })
})
